import classNames from 'classnames'
import { h, JSX } from 'preact'

import { PageLeftIcon, PageRightIcon } from '../icon/icon'

export interface PaginationItemProps {
    text?: string
    onClick: () => void
    isDisabled?: boolean
    isCurrent?: boolean
}

export interface PaginationProps {
    previous: PaginationItemProps
    next: PaginationItemProps
    pages: PaginationItemProps[]
}

const renderPaginationItem = (props: PaginationItemProps): JSX.Element => {
    const { text, onClick, isCurrent } = props

    const className = classNames('pagination__item', isCurrent && 'pagination__item--current')

    return (
        <div class={className} onClick={onClick}>
            {text}
        </div>
    )
}

export const Pagination = (props: PaginationProps): JSX.Element => {
    const { previous, next, pages } = props

    const previousClass = classNames(
        'pagination__item',
        previous.isDisabled && 'pagination__item--disabled',
    )

    const previousElement = (
        <div class={previousClass} onClick={previous.onClick}>
            <PageLeftIcon class="pagination__navigation" />
        </div>
    )

    const nextClass = classNames(
        'pagination__item',
        next.isDisabled && 'pagination__item--disabled',
    )

    const nextElement = (
        <div class={nextClass} onClick={next.onClick}>
            <PageRightIcon class="pagination__navigation" />
        </div>
    )

    return (
        <div class="pagination">
            <div class="pagination__inner">
                {previousElement}
                {pages.map(renderPaginationItem)}
                {nextElement}
            </div>
        </div>
    )
}
